<template>
  <div class="reference-structure-legend">
    <div class="reference-structure-legend__item">
      <span
          class="reference-structure-legend__mark"
          :style="{ backgroundColor: lowColor }"
      ></span>

      <span>Группа с низким показателем достижения KPI</span>
    </div>

    <div class="reference-structure-legend__item">
      <span
          class="reference-structure-legend__mark"
          :style="{ backgroundColor: highColor }"
      ></span>

      <span>Группа с высоким показателем достижения KPI</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReferenceStructureLegend",

  props: {
    lowColor: {
      type: String,
      required: true,
    },

    highColor: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.reference-structure-legend {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-bottom: 20px;
}

.reference-structure-legend__item {
  display: inline-flex;
  align-items: center;
  column-gap: 10px;
  min-width: 0;
  font-size: 14px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.58);
}

.reference-structure-legend__mark {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
}

@media (max-width: 640px) {
  .reference-structure-legend__item {
    font-size: 12px;
    line-height: 16px;
  }
}
</style>